import { useContext } from 'react';
import { ViewDepartmentContext } from 'src/sections/view_department/ViewDepartmentContext';

const useViewDepartments = () => {
  const context = useContext(ViewDepartmentContext);
  if (!context)
    throw new Error('View Checkbook context must be used inside ViewDepartmentContextProvider');
  return context;
};

export default useViewDepartments;
